import type { GroupviewPanelState } from 'dockview';
import type { ReactNode } from 'react';
import { SubTabBar } from '../../../../components/Mobile/TabBar/SubTabBar/SubTabBar';
import { useMobileTradingNavItems } from '../useMobileTradingNavItems';

interface MobileMarketPanelProps {
  panel: GroupviewPanelState;
  children: ReactNode;
}

/**
 * Shared mobile market shell: keeps the market-local sub-navigation mounted while switching between
 * Market Cards and Watchlist, so SubTabBar state/animations are not reset by remounts.
 */
export function MobileMarketPanel({ panel, children }: MobileMarketPanelProps) {
  const tradingNavItems = useMobileTradingNavItems();
  const parent = tradingNavItems.find(item => item.id === MARKET_NAV_ID);

  return (
    <>
      {children}
      {parent?.children?.length != null && parent.children.length > 0 && <SubTabBar parent={parent} />}
    </>
  );
}

const MARKET_NAV_ID = 'market';
